import { VotacionRemotaComponent } from './cliente/votacion-remota/votacion-remota.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './intranet/login/login.component';
import { AdminComponent } from './intranet/admin/admin.component';
import { ResultadoComponent } from './intranet/admin/resultado/resultado.component';
import { AsistenciaComponent } from './intranet/admin/asistencia/asistencia.component';
import { AccesoComponent } from './intranet/admin/acceso/acceso.component';
import { AsambleaComponent } from './intranet/admin/asamblea/asamblea.component';
import { RepresentanteComponent } from './intranet/admin/representante/representante.component';
import { AuthGuard } from './intranet/login/AuthGuard';
import { ValidacionAsistenteComponent } from './cliente/validacion-asistente/validacion-asistente.component';
import { VotacionComponent } from './cliente/votacion/votacion.component';
import { FinVotacionComponent } from './cliente/fin-votacion/fin-votacion.component';
import { AuthCliente } from './cliente/AuthCliente';
import { CambiarContraseniaComponent } from './intranet/login/cambiar-contrasenia/cambiar-contrasenia.component';
import { AsambleaBandejaComponent } from './intranet/admin/asamblea-bandeja/asamblea-bandeja.component';
import { BienvenidaAsistenteComponent } from './cliente/bienvenida-asistente/bienvenida-asistente.component';
import { ImportacionFondoComponent } from './intranet/admin/importacion-fondo/importacion-fondo.component';
import { VotacionEdicionComponent } from './cliente/votacion-edicion/votacion-edicion.component';

const routes: Routes = [
  { path: 'admin', component: AdminComponent, canActivate: [AuthGuard] },
  { path: 'ingreso', component: LoginComponent },
  { path: 'cambiarContrasenia', component: CambiarContraseniaComponent, canActivate: [AuthGuard] },
  { path: 'validacion', component: ValidacionAsistenteComponent },
  { path: 'votacion', component: VotacionComponent, canActivate: [AuthCliente] },
  { path: 'votacionRemota', component: VotacionRemotaComponent, canActivate: [AuthCliente] },
  { path: 'votacionEdicion', component: VotacionEdicionComponent, canActivate: [AuthCliente] },
  { path: 'finVotacion/:idAsamblea', component: FinVotacionComponent, canActivate: [AuthCliente]},
  { path: 'mntAcceso', component: AccesoComponent, canActivate: [AuthGuard] },
  { path: 'asistencia', component: AsistenciaComponent, canActivate: [AuthGuard] },
  { path: 'resultado', component: ResultadoComponent, canActivate: [AuthGuard] },
  { path: 'asamblea/:idAsamblea', component: AsambleaComponent, canActivate: [AuthGuard] },
  { path: 'asamblea', component: AsambleaComponent, canActivate: [AuthGuard] },
  { path: 'mntAsamblea', component: AsambleaBandejaComponent, canActivate: [AuthGuard] },
  { path: 'representante', component: RepresentanteComponent, canActivate: [AuthGuard] },
  { path: 'importacion', component: ImportacionFondoComponent, canActivate: [AuthGuard] },
  { path: 'bienvenido', component: BienvenidaAsistenteComponent, canActivate: [AuthCliente] },
  { path: '', redirectTo: '/validacion', pathMatch: 'full' },
  { path: '**', redirectTo: '/validacion' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
